module.exports = __webpack_public_path__ + "static/media/android_tips_03.e9ccfce0.png";